/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignMediaMessageRequest } from '../models/AssignMediaMessageRequest';
import type { AssignTrackedTipRequest } from '../models/AssignTrackedTipRequest';
import type { FanPpvStatistics } from '../models/FanPpvStatistics';
import type { NotificationCounts } from '../models/NotificationCounts';
import type { NotificationsFilterType } from '../models/NotificationsFilterType';
import type { OnlyFansChatDto } from '../models/OnlyFansChatDto';
import type { OnlyFansNotificationResult } from '../models/OnlyFansNotificationResult';
import type { SetUserPropertiesRequest } from '../models/SetUserPropertiesRequest';
import type { UpcomingBirthdaySet } from '../models/UpcomingBirthdaySet';
import type { UserList } from '../models/UserList';
import type { UserListRequest } from '../models/UserListRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfChatNotificationsService {
    /**
     * Synchronize fan time shift
     * Update fan time zone according to its location
     * @returns string Successfully update user time zone
     * @throws ApiError
     */
    public static updateUserTimeShiftChattingUi({
        creatorId,
        fanId,
    }: {
        creatorId: number,
        fanId: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/of-chat/{creatorId}/user/{fanId}/time-shift',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
            errors: {
                400: `Can't update fan id because location is wrong`,
                404: `No fan found by such id`,
            },
        });
    }
    /**
     * Update fan
     * @returns void
     * @throws ApiError
     */
    public static setUserProperties({
        creatorId,
        fanId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * Id of the fan
         */
        fanId: number,
        /**
         * The request object for updating fan
         */
        requestBody: SetUserPropertiesRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/user/{fanId}/update',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * @returns OnlyFansChatDto OK
     * @throws ApiError
     */
    public static unsubscribe({
        creatorId,
        fanId,
    }: {
        creatorId: number,
        fanId: number,
    }): CancelablePromise<OnlyFansChatDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/user/{fanId}/unsubscribe',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
        });
    }
    /**
     * @returns OnlyFansChatDto OK
     * @throws ApiError
     */
    public static subscribe({
        creatorId,
        fanId,
    }: {
        creatorId: number,
        fanId: number,
    }): CancelablePromise<OnlyFansChatDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/user/{fanId}/subscribe',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
        });
    }
    /**
     * Assign tip
     * Reassign tip to a chatting user
     * @returns void
     * @throws ApiError
     */
    public static assignTip({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The request object for assigning a tip
         */
        requestBody: AssignTrackedTipRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/notifications/assign/tip',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
            },
        });
    }
    /**
     * Assign media message
     * Reassign a media message to a chatting user
     * @returns void
     * @throws ApiError
     */
    public static assignMediaMessage({
        creatorId,
        requestBody,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The request object for assigning a media message
         */
        requestBody: AssignMediaMessageRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/notifications/assign/mediamessage',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Retrieve a list of users for a creator
     * Retrieves a paginated list of users for a specified creator based on filter parameters.
     * @returns UserList Successfully retrieved user list
     * @throws ApiError
     */
    public static getUsers({
        creatorId,
        offset,
        requestBody,
    }: {
        creatorId: number,
        offset: number,
        requestBody: UserListRequest,
    }): CancelablePromise<UserList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/listUser',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * @returns FanPpvStatistics OK
     * @throws ApiError
     */
    public static getUserPpvStatistics({
        creatorId,
        fanId,
    }: {
        creatorId: number,
        fanId: number,
    }): CancelablePromise<FanPpvStatistics> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/user/{fanId}/ppvStatistics',
            path: {
                'creatorId': creatorId,
                'fanId': fanId,
            },
        });
    }
    /**
     * Get upcoming birthdays
     * Get the upcoming birthdays
     * @returns UpcomingBirthdaySet Successfully retrieved upcoming birthdays
     * @throws ApiError
     */
    public static getUpcomingBirthdays({
        creatorId,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
    }): CancelablePromise<UpcomingBirthdaySet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/upcomingBirthdays',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `The user is missing the required permission or the creator does not exist.`,
            },
        });
    }
    /**
     * Get notifications
     * Fetch notifications for the specified creator.
     * @returns OnlyFansNotificationResult Successfully retrieved notifications
     * @throws ApiError
     */
    public static get({
        creatorId,
        type,
        anchorId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
        /**
         * The type of notifications to fetch (e.g., all, likes, purchases, subscribed, tip, commented, mentioned, favorited, message, deactivated_media)
         */
        type?: NotificationsFilterType,
        /**
         * The anchor ID for pagination
         */
        anchorId?: number,
    }): CancelablePromise<OnlyFansNotificationResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/notifications',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'type': type,
                'anchorId': anchorId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
    /**
     * Get unread notification count
     * Fetch unread notification counts for the specified creator.
     * @returns NotificationCounts Successfully retrieved notifications
     * @throws ApiError
     */
    public static count({
        creatorId,
    }: {
        /**
         * The creator id
         */
        creatorId: number,
    }): CancelablePromise<NotificationCounts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/notifications/count',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `No permission for this feature for this creator or creator has no access to this feature.`,
                409: `When the creator has not enabled the vault feature`,
                502: `When the OnlyFans API has an error`,
            },
        });
    }
}
